const KEY = 'sr-staff-pass';

export function getStaffPass(): string {
  try { return sessionStorage.getItem(KEY) ?? ''; } catch { return ''; }
}
export function setStaffPass(p: string | null) {
  try { if (p) sessionStorage.setItem(KEY, p); else sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
